import { render, staticRenderFns } from "./NoChoice.vue?vue&type=template&id=03bcad87"
import script from "./NoChoice.vue?vue&type=script&lang=js"
export * from "./NoChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports